import GloLayout from 'lowcode/common/GloLayout';
import ClientComp from './ClientComp';
import './index.scss';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    return (
        <GloLayout id={id} className={`temp-member-ways-to-earn-ecocredits temp-hide`}>
            <ClientComp data={data} />
        </GloLayout>
    );
}
